/*
  Shopable rosa — carrossel de videos verticais (estilo Tower 28).
  - Setas centralizam o proximo/anterior video (vira o "destaque").
  - So o video central toca; os demais PAUSAM no frame atual (nao reiniciam).
  - Mute por video; ao ativar o som de um, os outros sao mutados.
  - Loop infinito (opcional): clones nas duas pontas + "recentragem" invisivel.
*/
(function () {
  if (window.__shrBound) return;
  window.__shrBound = true;

  function centerOf(track, card) {
    // scrollLeft que deixa o card centralizado na pista
    return card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
  }

  function nearestIndex(track, cards) {
    var r = track.getBoundingClientRect();
    var mid = r.left + r.width / 2;
    var bi = 0, bd = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var cr = cards[i].getBoundingClientRect();
      var cc = cr.left + cr.width / 2;
      var d = Math.abs(cc - mid);
      if (d < bd) { bd = d; bi = i; }
    }
    return bi;
  }

  /* --------------------------------------------------------------- mute */
  document.addEventListener('click', function (e) {
    var mb = e.target.closest('.shr-mute');
    if (!mb) return;
    var sec = mb.closest('.shr-section');
    var card = mb.closest('.shr-card');
    var video = card && card.querySelector('video');
    if (!video || !sec) return;
    var willUnmute = video.muted;
    sec.querySelectorAll('.shr-card video').forEach(function (v) { v.muted = true; });
    sec.querySelectorAll('.shr-mute').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    if (willUnmute) {
      video.muted = false;
      var pr = video.play(); if (pr && pr.catch) pr.catch(function () {});
      mb.setAttribute('aria-pressed', 'true');
    }
  });

  /* -------------------------------------------------------- init secao */
  function initSection(sec) {
    var track = sec.querySelector('.shr-track');
    if (!track || track.__shrInit) return;
    track.__shrInit = true;

    var originals = Array.prototype.slice.call(track.querySelectorAll('.shr-card'));
    if (!originals.length) return;
    var N = originals.length;
    var loop = track.classList.contains('shr-track--loop') && N >= 2;

    // ----- clones p/ loop infinito -----
    var W = 0, C0 = 0, leftCount = 0;
    if (loop) {
      var items = parseInt(getComputedStyle(track).getPropertyValue('--items-d'), 10) || 4;
      var P = Math.max(2, Math.ceil((items + 1) / N)); // copias por lado
      leftCount = P * N;
      function makeClones() {
        var copies = [];
        var k;
        for (k = 0; k < P; k++) {
          originals.forEach(function (o) { copies.push(o.cloneNode(true)); });
        }
        return copies;
      }
      var before = makeClones();
      var after = makeClones();
      // ids unicos nos clones (evita ids duplicados no DOM)
      var stamp = 0;
      function sanitize(node) {
        stamp++;
        node.setAttribute('aria-hidden', 'true');
        node.querySelectorAll('[id]').forEach(function (el) { el.id = el.id + '--c' + stamp; });
        node.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = -1; });
      }
      before.forEach(sanitize);
      after.forEach(sanitize);
      var first = originals[0];
      before.forEach(function (n) { track.insertBefore(n, first); });
      after.forEach(function (n) { track.appendChild(n); });
    }

    function allCards() { return Array.prototype.slice.call(track.querySelectorAll('.shr-card')); }
    var cards = allCards();

    // periodo do loop em pixels EXATOS (distancia entre um card e seu clone N a frente)
    // e posicao de scroll que centraliza o 1o video original (referencia da banda)
    function measureLoop() {
      if (!loop) return;
      W = cards[N].offsetLeft - cards[0].offsetLeft;
      C0 = centerOf(track, cards[leftCount]);
    }
    measureLoop();

    // ----- destaque VISUAL (ao vivo, barato): so alterna a classe .is-active -----
    function activeCard() { return cards[nearestIndex(track, cards)]; }
    var lastVisual = null;
    function setActive(card) {
      if (!card || card === lastVisual) return;
      lastVisual = card;
      sec.__shrActive = card;
      // A classe marca o destaque SEMPRE: o efeito de zoom continua preso ao
      // modificador .shr-track--zoom no CSS, mas a barra de progresso tambem
      // depende dela para aparecer.
      for (var i = 0; i < cards.length; i++) cards[i].classList.toggle('is-active', cards[i] === card);
    }
    function updateActive() {
      // Durante a navegacao por seta/clique quem manda e o card alvo:
      // o scroll pode saturar antes de centraliza-lo (cards das pontas) e
      // o "mais proximo do centro" elegeria o card errado.
      if (animating) return;
      setActive(activeCard());
    }

    // ----- PLAYBACK (so quando o scroll para): toca o central, pausa o resto,
    //       pre-aquece os vizinhos imediatos e descarrega os distantes -----
    // Troca o preload e, quando preciso, forca o inicio do download: mudar o
    // atributo depois do elemento pronto nao dispara a carga sozinho na maioria
    // dos browsers — era por isso que o play do card recem-ativado travava.
    function warm(v, mode) {
      if (v.preload === mode) return;
      v.preload = mode;
      if (mode !== 'none' && v.readyState === 0) {
        try { v.load(); } catch (e) {}
      }
    }

    // liga a barra ao tempo real do video (uma vez por elemento)
    function bindProgress(v, c) {
      if (v.__shrProg) return;
      v.__shrProg = true;
      var bar = c.querySelector('.shr-progress i');
      if (!bar) return;
      v.addEventListener('timeupdate', function () {
        var d = v.duration;
        if (!d || !isFinite(d)) return;
        bar.style.width = (v.currentTime / d) * 100 + '%';
      });
      v.addEventListener('ended', function () { bar.style.width = '0%'; });
    }

    var lastPlayed = null;
    function applyPlayback() {
      var card = sec.__shrActive || activeCard();
      if (!card || card === lastPlayed) return;
      lastPlayed = card;
      var ai = cards.indexOf(card);
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        c.classList.remove('is-paused');
        var v = c.querySelector('video');
        if (!v) continue;
        if (c === card) {
          warm(v, 'auto');
          bindProgress(v, c);
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else {
          v.pause(); // pausa no frame atual (nao reseta)
          // vizinho imediato ja carregado: quando a seta chega nele o play e
          // instantaneo. Os demais ficam em metadata (nunca 'none', que
          // obrigava a baixar tudo do zero na hora do play).
          warm(v, Math.abs(i - ai) <= 1 ? 'auto' : 'metadata');
        }
      }
    }

    // ----- recentragem AO VIVO (invisivel: conteudo identico a cada W) -----
    var animating = false;
    function recenter() {
      if (!loop || animating || !W) return;
      var x = track.scrollLeft, half = W / 2;
      while (x < C0 - half) x += W;
      while (x >= C0 + half) x -= W;
      if (Math.abs(x - track.scrollLeft) > 0.5) track.scrollLeft = x;
    }

    // ----- scroll handler: visual ao vivo; play/pause so no repouso (debounce) -----
    var raf = false, settle = null;
    track.addEventListener('scroll', function () {
      if (!raf) {
        raf = true;
        requestAnimationFrame(function () { raf = false; recenter(); updateActive(); });
      }
      if (settle) clearTimeout(settle);
      settle = setTimeout(applyPlayback, 160);
    }, { passive: true });
    window.addEventListener('resize', function () { measureLoop(); recenter(); updateActive(); });

    // ----- centraliza um card especifico -----
    function centerTo(card) {
      if (!card) return;
      animating = true;
      // Marca o alvo ANTES de rolar: quando o card nao pode ser centralizado
      // (pontas, com o scrollLeft no limite) o "mais proximo do centro" nunca
      // o elegeria, e o video dele nunca tocaria.
      setActive(card);
      track.scrollTo({ left: centerOf(track, card), behavior: 'smooth' });
      setTimeout(function () {
        animating = false;
        recenter();
        applyPlayback();
      }, 500);
    }
    // ----- setas: normaliza a posicao e centraliza o proximo/anterior -----
    function go(dir) {
      recenter(); // garante que partimos do meio da banda (nunca da borda do buffer)
      // Parte do card ATIVO, nao do "mais proximo do centro": quando restam
      // menos cards do que cabem na pista o scroll satura, o card central para
      // de mudar e a navegacao por posicao trava nas pontas.
      var i = sec.__shrActive ? cards.indexOf(sec.__shrActive) : -1;
      if (i < 0) i = nearestIndex(track, cards);
      var ni = i + (dir > 0 ? 1 : -1);
      if (ni < 0) ni = 0;
      if (ni > cards.length - 1) ni = cards.length - 1;
      centerTo(cards[ni]);
    }
    sec.__shrGo = go;
    sec.__shrCenter = centerTo;

    // ----- estado inicial: centraliza o 1o video original -----
    track.scrollLeft = loop ? C0 : 0;
    updateActive();
    // Velocidade (26/10/2026): só baixa/toca o vídeo central quando a seção chega perto da tela (antes baixava 3 vídeos no carregamento).
    if ('IntersectionObserver' in window) {
      var shrIo = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { shrIo.disconnect();
        sec.querySelectorAll('video[data-poster]').forEach(function (v) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); });   // pôster só perto da tela (26/10/2026)
        applyPlayback(); } }, { rootMargin: '600px 0px' });
      shrIo.observe(sec);
    } else { sec.querySelectorAll('video[data-poster]').forEach(function (v) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); }); applyPlayback(); }
  }

  /* setas (delegacao) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.shr-arrow');
    if (!btn) return;
    var sec = btn.closest('.shr-section');
    if (!sec || !sec.__shrGo) return;
    sec.__shrGo(btn.classList.contains('shr-arrow--next') ? 1 : -1);
  });

  /* clique no video: central -> pausa/play; lateral -> centraliza
     (sem atrapalhar produto / + / mute) */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.shr-prod') || e.target.closest('.shr-mute') || e.target.closest('.shr-arrow')) return;
    var card = e.target.closest('.shr-card');
    if (!card) return;
    var sec = card.closest('.shr-section');
    if (!sec) return;
    if (card === sec.__shrActive) {
      var v = card.querySelector('video');
      if (!v) return;
      if (v.paused) {
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        card.classList.remove('is-paused');
      } else {
        v.pause();
        card.classList.add('is-paused');
      }
    } else if (sec.__shrCenter) {
      sec.__shrCenter(card);
    }
  });

  function initAll() { document.querySelectorAll('.shr-section').forEach(initSection); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var s = (e.target.classList && e.target.classList.contains('shr-section'))
      ? e.target : (e.target.querySelector && e.target.querySelector('.shr-section'));
    if (s) { var t = s.querySelector('.shr-track'); if (t) t.__shrInit = false; initSection(s); }
  });
})();
